import genericRule from '../../namespace/relation/doingChange_namespace_relation';
import { state, selectedAddresses, presentation } from './session';
export default {
    ...genericRule,
    excludedNamespaceRelations: [],
    namespace: 'application',
    relation: 'readerSetup',
    logic: args => {
        const result = genericRule.logic(args);
        const setup = state(args.context);
        if (setup.draft._id === result.newRecord._id) {
            if (['readerChoices', 'readerAddress', 'manualAddress'].includes(args.data.propertyName)) {
                if (result.newRecord.credentialsRequested) result.newRecord.requestStatus = '';
                result.newRecord.credentialsRequested = false;
                result.newRecord.readerPassword = '';
                result.newRecord.mqttPassword = '';
            }
            if (
                JSON.stringify(setup.draft.readerChoices?.map(row => row._id)) !==
                JSON.stringify(result.newRecord.readerChoices?.map(row => row._id))
            ) {
                result.newRecord.readerAddress = '';
                result.newRecord.readyToConnect = false;
                result.newRecord.reviewErrors = {};
            }
            if (
                args.data.propertyName === 'readerAddress' &&
                setup.draft.readerAddress !== result.newRecord.readerAddress
            ) {
                result.newRecord.readerChoices = [];
                result.newRecord.reviewErrors = {};
            }
            if (setup.draft.countryChoice?._id !== result.newRecord.countryChoice?._id) {
                result.newRecord.regionName = result.newRecord.countryChoice?.title || '';
                result.newRecord.standardName = '';
                result.newRecord.advancedRegion = false;
            }
            if (setup.draft.readerAddress !== result.newRecord.readerAddress) {
                Object.assign(result.newRecord, {
                    readerName: '',
                    readerId: undefined,
                    regionName: '',
                    countryChoice: undefined,
                    standardName: '',
                    needsRegion: false,
                    advancedRegion: false,
                    readyToConnect: false,
                    settingsSummary: ''
                });
            }
            if (args.data.propertyName === 'manualAddress' && !result.newRecord.manualAddress) {
                result.newRecord.readerAddress = '';
            }
            const addresses = selectedAddresses(result.newRecord);
            result.newRecord.readyToConnect = (result.newRecord.readerProgress || []).some(
                row => addresses.includes(row._id) && row.status === 'Awaiting confirmation'
            );
            result.newRecord.hasReadersSelected = selectedAddresses(result.newRecord).length > 0;
            result.newRecord = presentation(result.newRecord);
            setup.draft = result.newRecord;
        }
        return result;
    }
};
